import { AdminRole } from '@por/consumer-login/shared-lib';
import { Searchable } from './searchable.model';
import { User } from './user.interface';

/* eslint-disable @typescript-eslint/naming-convention */
// Note camelCase: DB attributes
export class Auth {
    OrganizationId?: string;
    accessToken?: string;
    RefreshToken?: string;
    Email?: string;
    customerId?: string;
    contactId?: string;
    OrganizationType?: string;
    CompanyName?: string;
    Name?: string;
    Role?: AdminRole[];
}

// TODO: Remove this after including Name as part of Auth
export interface UserLogin extends Searchable {
    accessToken: string;
    RefreshToken: string;
    OrganizationType: string;
    name?: string;
    CompanyName?: string;
    Role?: AdminRole[];
}

export type AuthData = Auth & User;
